
function App() {
  return (
    <div className="App">
      Welcome...
    </div>
  );
}

export default App;
